export const firebaseConfig = {
  apiKey: "AIzaSyBK61hlEibmu-ihjqLp5DtyTrEiwfWmtj0",
  authDomain: "ce-website-test.firebaseapp.com",
  projectId: "ce-website-test",
  storageBucket: "ce-website-test.appspot.com",
  messagingSenderId: "661045100823",
  appId: "1:661045100823:web:e3e08386bd20d3ff8ab752",
  measurementId: "G-V8Z0H0LK2V",
};
